export const LeaderBoardHeader = () => {
  return (
    <div className="main-trapezoid for-leaderboard">
      <div className="trapezoid leaderboard">
        <span className="header">Leaderboard</span>
      </div>
      <div className="minis">
        <div className="mini-trapezoid"></div>
        <div className="mini-trapezoid"></div>
      </div>
    </div>
  );
};
